module.exports = __webpack_public_path__ + "img/15.771e512.png";